module.exports = __webpack_public_path__ + "img/about_5.5eaf2019.jpg";